import { trace } from "./../shared/helpers.js"

class Project {
  /**
  * @constructor
  **/
  constructor() {
    if ($('html').hasClass("project-page")) {
      this.init();
    }
  }

  checkFooter() {
    $('.main-content').css("min-height", 0);
    let wH = window.innerHeight;
    let hH = $('header').outerHeight() + 20;
    let fH = $('footer').outerHeight() + 40;
    trace(wH, hH, fH);
    let minH = Math.round(wH - hH - fH);
    trace(minH);
    if ($('.main-content').outerHeight() < minH) {
      $('.main-content').css("min-height", minH + "px");
    }
  }

  onWindowResize() {
    this.checkFooter();
  }


  init() {
    this.onWindowResize();
    $(window).on( 'DOMContentLoaded load resize', $.proxy(this.onWindowResize, this)); 

    setTimeout(()=> {
      $('html').addClass("project-page-ready");
    }, 200);
  }

}
export default Project
